import { push } from "connected-react-router";
import moment from "moment";
import { actions as creditBillActions } from "reducers/creditBills";
import {
    billTabs,
    INFORM_CBU,
    RETURN,
    RETURN_ANULATE,
    RETURN_ACCEPT,
    RETURN_DECLINE,
    TRANSMISSION,
    TRANSMISSION_ADMIT,
    TRANSMISSION_ANULATE,
    TRANSMISSION_REPUDIATE,
    validateAction,
    monedas,
} from "util/creditBills";
import * as i18n from "util/i18n";

export const navigateBillAction = (action, invoiceList, dispatch, tabOption) => {
    const actionLoweCase = action.toLowerCase();

    const quantity = invoiceList.reduce((sum, item) => sum + item.saldoAceptado, 0);
    const everyHasSameCurrency = invoiceList.every((item) => item.moneda === invoiceList[0].moneda);
    const currency = everyHasSameCurrency ? monedas[invoiceList[0].moneda] : "";
    const amount = { quantity, currency };

    switch (action) {
        case TRANSMISSION_ADMIT: {
            dispatch(
                creditBillActions.setActionData({ invoiceList, amount, action, tabOption, transmissionType: "NOM" }),
            );
            dispatch(push({ pathname: `/creditBills/${actionLoweCase}/confirm` }));
            break;
        }
        case RETURN_ACCEPT: {
            dispatch(creditBillActions.setActionData({ invoiceList, amount, action, tabOption }));
            dispatch(push({ pathname: `/creditBills/${actionLoweCase}/confirm` }));

            break;
        }
        case INFORM_CBU: {
            dispatch(creditBillActions.setActionData({ invoiceList, amount, action, tabOption }));
            dispatch(push("/creditBills/inform/modify"));

            break;
        }
        default:
            dispatch(creditBillActions.setActionData({ invoiceList, amount, action, tabOption }));
            dispatch(push({ pathname: `/creditBills/${actionLoweCase}` }));
            break;
    }
};

export const getBillActions = (tabOption, bill, dispatch) => {
    // eslint-disable-next-line prefer-const
    let actionOptions = [];
    const invoiceList = [bill];
    const { transmission, returnFcem, canInformFromTenure, canInformFromPay } = validateAction(bill);

    switch (tabOption) {
        case billTabs.EMITTED: {
            if (transmission.canTransmit) {
                actionOptions.push({
                    value: TRANSMISSION,
                    label: "creditBill.action.transmit",
                    onClick: () => navigateBillAction(TRANSMISSION, invoiceList, dispatch, tabOption),
                });
            }
            if (returnFcem.canDecline) {
                actionOptions.push({
                    value: RETURN_DECLINE,
                    label: "creditBill.action.return.decline",
                    onClick: () => navigateBillAction(RETURN_DECLINE, invoiceList, dispatch, tabOption),
                });
            }
            break;
        }
        case billTabs.IN_TENURE:
            if (transmission.canTransmit) {
                actionOptions.push({
                    value: TRANSMISSION,
                    label: "creditBill.action.transmit",
                    onClick: () => navigateBillAction(TRANSMISSION, invoiceList, dispatch, tabOption),
                });
            }
            if (transmission.canAnulate) {
                actionOptions.push({
                    value: TRANSMISSION_ANULATE,
                    label: "creditBill.action.anulate.transmission",
                    onClick: () => navigateBillAction(TRANSMISSION_ANULATE, invoiceList, dispatch, tabOption),
                });
            }
            if (returnFcem.canAccept) {
                actionOptions.push({
                    value: RETURN_ACCEPT,
                    label: "creditBill.action.return.accept",
                    onClick: () => navigateBillAction(RETURN_ACCEPT, invoiceList, dispatch, tabOption),
                });
            }
            if (returnFcem.canDecline) {
                actionOptions.push({
                    value: RETURN_DECLINE,
                    label: "creditBill.action.return.decline",
                    onClick: () => navigateBillAction(RETURN_DECLINE, invoiceList, dispatch, tabOption),
                });
            }
            if (canInformFromTenure) {
                actionOptions.push({
                    value: INFORM_CBU,
                    label: "creditBill.action.inform",
                    onClick: () => navigateBillAction(INFORM_CBU, invoiceList, dispatch, tabOption),
                });
            }

            break;
        case billTabs.TO_PAY:
            if (returnFcem.canReturn) {
                actionOptions.push({
                    value: RETURN,
                    label: "creditBill.action.return",
                    onClick: () => navigateBillAction(RETURN, invoiceList, dispatch, tabOption),
                });
            }
            if (returnFcem.canAnulate) {
                actionOptions.push({
                    value: RETURN_ANULATE,
                    label: "creditBill.action.return.anulate",
                    onClick: () => navigateBillAction(RETURN_ANULATE, invoiceList, dispatch, tabOption),
                });
            }
            if (canInformFromPay) {
                actionOptions.push({
                    value: INFORM_CBU,
                    label: "creditBill.action.inform",
                    onClick: () => navigateBillAction(INFORM_CBU, invoiceList, dispatch, tabOption),
                });
            }
            break;
        case billTabs.RECEIVED: {
            if (transmission.canAdmit) {
                actionOptions.push({
                    value: TRANSMISSION_ADMIT,
                    label: "creditBill.action.admin.transmission",
                    onClick: () => navigateBillAction(TRANSMISSION_ADMIT, invoiceList, dispatch, tabOption),
                });
            }
            if (transmission.canRepudiate) {
                actionOptions.push({
                    value: TRANSMISSION_REPUDIATE,
                    label: "creditBill.action.repudiate.transmission",
                    onClick: () => navigateBillAction(TRANSMISSION_REPUDIATE, invoiceList, dispatch, tabOption),
                });
            }
            break;
        }
        default:
            break;
    }
    return actionOptions;
};

const enableMultipleOption = (bills, action, tabOption = "") => {
    const validations = bills.map((bill) => validateAction(bill));

    switch (action) {
        case TRANSMISSION:
            return validations.every(({ transmission }) => transmission.canTransmit);
        case TRANSMISSION_ANULATE:
            return validations.every(({ transmission }) => transmission.canAnulate);
        case TRANSMISSION_ADMIT:
            return validations.every(({ transmission }) => transmission.canAdmit);
        case TRANSMISSION_REPUDIATE:
            return validations.every(({ transmission }) => transmission.canRepudiate);
        case RETURN:
            return validations.every(({ returnFcem }) => returnFcem.canReturn);
        case RETURN_ANULATE:
            return validations.every(({ returnFcem }) => returnFcem.canAnulate);
        case RETURN_ACCEPT:
            return validations.every(({ returnFcem }) => returnFcem.canAccept);
        case RETURN_DECLINE:
            return validations.every(({ returnFcem }) => returnFcem.canDecline);
        case INFORM_CBU:
            if (tabOption === billTabs.IN_TENURE) {
                return validations.every((validation) => validation.canInformFromTenure);
            }
            if (tabOption === billTabs.TO_PAY) {
                return validations.every((validation) => validation.canInformFromPay);
            }
            return false;

        default:
            return false;
    }
};

export const getMultipleBillActions = (bills, tabOption) => {
    switch (tabOption) {
        case billTabs.EMITTED:
            return [
                {
                    value: TRANSMISSION,
                    label: i18n.get("creditBill.action.transmit"),
                    disabled: !enableMultipleOption(bills, TRANSMISSION),
                },
                {
                    value: RETURN_DECLINE,
                    label: i18n.get("creditBill.action.return.decline"),
                    disabled: !enableMultipleOption(bills, RETURN_DECLINE),
                },
            ];
        case billTabs.IN_TENURE:
            return [
                {
                    value: TRANSMISSION,
                    label: i18n.get("creditBill.action.transmit"),
                    disabled: !enableMultipleOption(bills, TRANSMISSION),
                },
                {
                    value: TRANSMISSION_ANULATE,
                    label: i18n.get("creditBill.action.anulate.transmission"),
                    disabled: !enableMultipleOption(bills, TRANSMISSION_ANULATE),
                },
                {
                    value: RETURN_ACCEPT,
                    label: i18n.get("creditBill.action.return.accept"),
                    disabled: !enableMultipleOption(bills, RETURN_ACCEPT),
                },
                {
                    value: RETURN_DECLINE,
                    label: i18n.get("creditBill.action.return.decline"),
                    disabled: !enableMultipleOption(bills, RETURN_DECLINE),
                },
                {
                    value: INFORM_CBU,
                    label: i18n.get("creditBill.action.inform"),
                    disabled: !enableMultipleOption(bills, INFORM_CBU, tabOption),
                },
            ];
        case billTabs.TO_PAY:
            return [
                {
                    value: RETURN,
                    label: i18n.get("creditBill.action.return"),
                    disabled: !enableMultipleOption(bills, RETURN, tabOption),
                },
                {
                    value: RETURN_ANULATE,
                    label: i18n.get("creditBill.action.return.anulate"),
                    disabled: !enableMultipleOption(bills, RETURN_ANULATE, tabOption),
                },
                {
                    value: INFORM_CBU,
                    label: i18n.get("creditBill.action.inform"),
                    disabled: !enableMultipleOption(bills, INFORM_CBU, tabOption),
                },
            ];
        case billTabs.RECEIVED:
            return [
                {
                    value: TRANSMISSION_ADMIT,
                    label: i18n.get("creditBill.action.admin.transmission"),
                    disabled: !enableMultipleOption(bills, TRANSMISSION_ADMIT, tabOption),
                },
                {
                    value: TRANSMISSION_REPUDIATE,
                    label: i18n.get("creditBill.action.repudiate.transmission"),
                    disabled: !enableMultipleOption(bills, TRANSMISSION_REPUDIATE, tabOption),
                },
            ];
        default:
            return [];
    }
};

export const checkDisableMultiple = (bill, tabOption) => {
    const { transmission, returnFcem, canInformFromTenure, canInformFromPay } = validateAction(bill);

    const isExpired = moment(bill.fechaVencimientoPago)
        .add("days", 1)
        .isSameOrBefore(moment());

    if (isExpired) {
        return true;
    }

    switch (tabOption) {
        case billTabs.EMITTED:
            return !(transmission.canTransmit || returnFcem.canDecline);
        case billTabs.IN_TENURE:
            return !(
                transmission.canTransmit ||
                transmission.canAnulate ||
                returnFcem.canAccept ||
                returnFcem.canDecline ||
                canInformFromTenure
            );
        case billTabs.TO_PAY:
            return !(returnFcem.canReturn || returnFcem.canAnulate || canInformFromPay);
        case billTabs.RECEIVED:
            return !(transmission.canAdmit || transmission.canRepudiate);
        default:
            return true;
    }
};
